import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Stage } from '@core/stages-types';
import { HeadingComponent } from '@core/user-interface-legacy';

import { AnonymousLearnMoreTriggerComponent } from '../anonymous-learn-more-trigger/anonymous-learn-more-trigger.component';

@Component({
  selector: 'rt-anonymous-info-bar',
  templateUrl: './anonymous-info-bar.component.html',
  styleUrls: ['./anonymous-info-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadingComponent,
    TranslatePipe,
    AnonymousLearnMoreTriggerComponent,
    AnonymousLearnMoreTriggerComponent,
  ],
  host: {
    '[class.no-radius]': 'noRadius()',
  },
})
export class AnonymousInfoBarComponent {
  public anonymousStage = input.required<Stage | null | undefined>();

  public noRadius = input<boolean, boolean | string>(false, { transform: booleanAttribute });
}
